<template>
  <v-app>
    <div  v-if="!maintenance" class="maindiv">
      <router-view/>
    </div>
    <div v-if="maintenance">
      <!-- <ComingSoon></ComingSoon> -->
      <Maintenance></Maintenance>
    </div>
  </v-app>

</template>

<script>
// import ComingSoon from './views/ComingSoon.vue';
import Maintenance from './views/Maintenance.vue';

export default {
  data() {
    return {
      maintenance: 0,
    };
  },
  components: {
    // ComingSoon,
    Maintenance,
  },
};
</script>

<style lang="scss">
  @import './assets/scss/style.scss';
</style>
